module.exports = "<div class=\"vcm_forgot_password_page_container\">\r\n    <router-outlet></router-outlet>\r\n</div>";